import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { HierarchyReadDto } from "./HierarchyReadDto";
import { HierarchyReadDtoDataReturn } from "./loadHierarchy";
import { HierarchySaveDto, HierarchyUpdateDto } from "./saveHierarchyData";

export type ICopyReportReturn = IAxiosReturn<HierarchyReadDto>;

/**
 * Restore a report from a backup version.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchy - The hierarchy save DTO with version info
 * @returns The restored hierarchy wrapped in HierarchyReadDtoDataReturn
 */
export const restoreBackupReport = async (
  backEndUrl: string,
  hierarchy: HierarchySaveDto,
): Promise<HierarchyReadDtoDataReturn> => {
  const url = new URL(
    `${backEndUrl}Reports/${
      (hierarchy as HierarchyUpdateDto).id
    }/RestoreBackupVersion?parentTag=${(hierarchy as HierarchyUpdateDto).parentTag}`,
  );
  try {
    const response = await axios.post(url.href);
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Restore Backup report failed", error);
  }
};
